//@flow
import {useMemo, useState} from "react";
import {useDebouncedCallback} from "use-debounce";
import {useOrderData} from "../order/useOrderData";
import {getDiscountQuantity} from "../../helpers/helpers";

const useProductQuantity = (product, orderType, orderId = null, onCommit, delay = 1000, readOnly = false, selectionMode = 'prefer-active-order-of-type') => {
    const {activeOrder} = useOrderData()

    // Derived from Redux on every render — no effect, never a stale mirror.
    const committedQuantity = useMemo(() => {
        if (readOnly) return Number(product.quantity) || 0
        if (selectionMode === 'specific-order' && orderId) {
            const order = activeOrder.find(o => o.id === orderId)
            const line = order?.products?.find(p => p.id === product.id)
            return line ? Number(line.quantity) : Number(product.quantity) || 0
        }
        if (orderId) return Number(product.quantity) || 0
        const order = activeOrder.find(o => o.type === orderType)
        const line = order?.products?.find(p => p.id === product.id)
        return line ? Number(line.quantity) : 0
    }, [activeOrder, orderId, orderType, product.id, product.quantity, readOnly, selectionMode])

    // Optimistic value shown only while an edit is debouncing. null => show committed.
    const [pending, setPending] = useState(null)

    const commit = useDebouncedCallback((qty) => {
        if (typeof onCommit === 'function') onCommit(qty)
    }, delay)

    // Clear the optimistic value once Redux reflects it (render-phase reconciliation, not an effect).
    if (pending != null && committedQuantity === pending) {
        setPending(null)
    }

    const quantity = pending != null ? pending : committedQuantity

    const setQuantity = (qty) => {
        setPending(qty)
        commit(qty)
    }

    return {
        quantity,
        discountQuantity: getDiscountQuantity(product, quantity),
        setQuantity,
    }
}

export default useProductQuantity
